export default __webpack_public_path__ + "static/media/aboutmobile.ac471aa5.webp";